<div class="sw-cms-preview-block-moorl-column-layout-3-2">
    <div></div>
    <div></div>
</div>